import { DISPLAY_TYPE_MAP } from '@/constants'

export default {
  user: {
    id: '',
    name: '',
    picture: ''
  },
  devices: [],
  infoDeviceId: '',
  reloadMap: false,
  provider: {
    oidcProviderName: '',
    idpIdentifier: '',
    displayType: DISPLAY_TYPE_MAP,
    groupId: '',
    groupName: '',
    groupLineOfficialAccountName: ''
  }
}
